import React from "react";
import { PanelEditEmailProvider } from "../../../UI/EmailProviders/Edit/PanelEditEmailProvider";


const EditEmailProvider = () => {
  return (
    <div>
      <PanelEditEmailProvider />
    </div>
  );
};

export default EditEmailProvider;
